import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const RefetchFilledIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M12.9999 3.25C8.17994 3.25 4.24994 7.18 4.24994 12V12.19L3.52994 11.47C3.23994 11.18 2.75994 11.18 2.46994 11.47C2.17994 11.76 2.17994 12.24 2.46994 12.53L4.46994 14.53C4.61994 14.68 4.80994 14.75 4.99994 14.75C5.18994 14.75 5.37994 14.68 5.52994 14.53L7.52994 12.53C7.81994 12.24 7.81994 11.76 7.52994 11.47C7.23994 11.18 6.75994 11.18 6.46994 11.47L5.74994 12.19V12C5.74994 8 8.99994 4.75 12.9999 4.75C16.9999 4.75 20.2499 8 20.2499 12C20.2499 16 16.9999 19.25 12.9999 19.25C12.5899 19.25 12.2499 19.59 12.2499 20C12.2499 20.41 12.5899 20.75 12.9999 20.75C17.8299 20.75 21.7499 16.83 21.7499 12C21.7499 7.17 17.8299 3.25 12.9999 3.25Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

RefetchFilledIcon.displayName = 'RefetchFilledIcon';
